var parent = require(2);
require(100);
// TODO: Remove from `core-js@4`
require(101);
require(103);
require(102);

module.exports = parent;
